import Business from "@mui/icons-material/Business";
import Call from "@mui/icons-material/Call";
import Chat from "@mui/icons-material/Chat";
import ConnectWithoutContact from "@mui/icons-material/ConnectWithoutContact";
import Email from "@mui/icons-material/Email";
import Groups from "@mui/icons-material/Groups";
import Instagram from "@mui/icons-material/Instagram";
import QrCode from "@mui/icons-material/QrCode";
import Store from "@mui/icons-material/Store";
import Twitter from "@mui/icons-material/Twitter";
import TwoWheeler from "@mui/icons-material/TwoWheeler";

export const COMMUNICATION_METHOD_ICON_CODES = [
  "Chat",
  "Call",
  "TwoWheeler",
  "Groups",
  "Instagram",
  "Email",
  "Twitter",
  "ConnectWithoutContact",
  "QrCode",
  "Business",
  "Store",
];

export const DEFAULT_COMMUNICATION_METHOD_ICON = "Chat";

export const DEFAULT_ULTRAMSG_GROUP_ID = "966503313930-1524579966@g.us";

export const COMMUNICATION_METHOD_ICON_MAP = {
  Chat,
  Call,
  TwoWheeler,
  Groups,
  Instagram,
  Email,
  Twitter,
  ConnectWithoutContact,
  QrCode,
  Business,
  Store,
};

export const getCommunicationMethodIcon = (iconCode) =>
  COMMUNICATION_METHOD_ICON_MAP[iconCode] || Chat;
